
export default {
    // metodos globales
    install(Vue) {
        Vue.prototype.$goToSection = function (id, route = null) {
            const scrollToElement = () => {
                const el = document.getElementById(id);
                if (el) {
                    const offset = el.getBoundingClientRect().top + window.pageYOffset - 80;
                    window.scrollTo({ top: offset, behavior: 'smooth' });
                }
            };
            if (route && this.$route.path !== route) {
                // Navegar a la ruta deseada y esperar que se monte
                this.$router.push(route).then(() => {
                    // Esperar al siguiente render para que exista el DOM objetivo
                    this.$nextTick(() => {
                        // Puede que aún no esté montado el DOM, así que espera un poco más
                        setTimeout(scrollToElement, 300);
                    });
                });
            } else {
                // Si ya estamos en la ruta, simplemente desplazarse
                this.$nextTick(scrollToElement);
            }
        };
        Vue.prototype.$formatCurrency = function (value, currencyCode = 'USD') {
            const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(value);

            return formattedValue;
        };
        Vue.prototype.$copyText = function (text) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(text)
                    .then(() => {
                        this.$swal.fire({
                            position: 'center',
                            html: `Texto copiado`,
                            icon: 'success',
                            confirmButtonText: 'Cerrar',
                            showCloseButton: false,
                            showConfirmButton: false,
                            timer: 1000,
                            backdrop: false,
                        })
                    })
                    .catch((error) => {
                        console.error("Error al copiar el texto: ", error);
                    });
            }
            else {
                // Fallback para navegadores más antiguos
                // Crear un elemento de texto temporal
                let inputTemp = document.createElement("input");
                inputTemp.value = text;
                document.body.appendChild(inputTemp);

                // Seleccionar el contenido del input
                inputTemp.select();
                document.execCommand("copy");

                // Eliminar el input temporal
                document.body.removeChild(inputTemp);

                this.$swal.fire({
                    position: 'center',
                    html: `Texto copiado`,
                    icon: 'success',
                    confirmButtonText: 'Cerrar',
                    showCloseButton: false,
                    showConfirmButton: false,
                    timer: 1000,
                    backdrop: false,
                })
            }
        };

    }
}